module.exports = __webpack_public_path__ + "static/fom.81023670.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fom.png
// module id = 644
// module chunks = 114276838955818